import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { ABTestManager } from '@/components/analytics/ABTestManager';
import { ABTestResults } from '@/components/analytics/ABTestResults';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useState } from 'react';

export default function ABTesting() {
  const [selectedExperiment, setSelectedExperiment] = useState<string | null>(null);

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold">A/B Testing</h1>
          <p className="text-muted-foreground">Run experiments to optimize your conversion rates</p>
        </div>

        <Tabs defaultValue="manager" className="w-full">
          <TabsList>
            <TabsTrigger value="manager">Experiments</TabsTrigger>
            <TabsTrigger value="results" disabled={!selectedExperiment}>
              Results
            </TabsTrigger>
          </TabsList>

          <TabsContent value="manager" className="space-y-4">
            <ABTestManager />
          </TabsContent>

          <TabsContent value="results" className="space-y-4">
            {selectedExperiment ? (
              <ABTestResults experimentId={selectedExperiment} />
            ) : (
              <p className="text-center text-muted-foreground py-8">
                Select an experiment to view results
              </p>
            )}
          </TabsContent>
        </Tabs>
      </div>
    </DashboardLayout>
  );
}
